import React, { Component } from 'react';
import { urlContains, setCurrentUrl } from '../../Common/Helpers/UrlHelper';
import { isLoggedIn } from '../../Auth/TokenManager';

const loggedIn = isLoggedIn();

const VisitorRouter = (ComponentName) => {
      return class extends Component {
            render() {
                  let isLoginPage = urlContains('login');
                  let isRegisterPage = urlContains("register");

                  return (loggedIn && (isLoginPage || isRegisterPage))
                        ? setCurrentUrl('/account/dashboard/order')
                        : <ComponentName {...this.props} />
            }
      }

}
export default VisitorRouter;


// WEBPACK FOOTER //
// ./src/Routes/routesTypes/VisitorRouter.js